<div class="widget-map-container" [ngClass]="{'full-height': widgetType === 'wm-form'}">
    <table class="wm-table">
        <colgroup>
            <col width="32" />
            <col width="250" />
            <col width="200" />
            <col />
        </colgroup>
        <thead>
            <tr>
                <th class="text-center"><input class="app-checkbox" type="checkbox" [ngClass]="{'ng-empty': !currentStep?.componentDefnObject?.isSelectAll, 'ng-not-empty': currentStep?.componentDefnObject?.isSelectAll}"
                        [ngModel]="currentStep?.componentDefnObject?.isSelectAll" (ngModelChange)="selectAll($event)" /></th>
                <th>{{locale.LABEL_WIDGET_DESIGNER_FIELD}}</th>
                <th>{{locale.LABEL_WIDGET_DESIGNER_TITLE}}</th>
                <th>{{locale.LABEL_VIEW_AS}}</th>
            </tr>
        </thead>
    </table>
    <div class="field-map wm-table-container" id="widgetFieldMap">
        <table class="wm-table">
            <colgroup>
                <col width="32" />
                <col width="250" />
                <col width="200" />
                <col />
            </colgroup>
            <tbody *ngFor="let field of currentStep.primitiveTypes">
                <tr class="field" (click)="onRowSelect(field, 'field')"
                    [ngClass]="{active:field === currentStep.selectedComponent.field, 'marked-deleted': field.remove}">
                    <td class="text-center select"><input class="app-checkbox" type="checkbox" [ngClass]="{'ng-empty': !field.pcDisplay, 'ng-not-empty': field.pcDisplay}"
                           (click)="$event.stopPropagation()" [ngModel]="field.pcDisplay" (ngModelChange)="onColSelect('pcDisplay', field, $event)" /></td>
                    <td><span class="title" title="{{ field.field}}">{{ field.field}}</span></td>
                    <td>
                        <input class="form-control app-textbox"
                            [ngModel]="field.displayName" pattern=".*" accesskey="" (click)="$event.stopPropagation()"
                            (ngModelChange)="updateFieldName(field, 'field', $event)"
                            (ngModelOptions)="{ updateOn: 'blur, change', debounce: 0 ,allowInvalid: false}"
                            name="wm-widget-config-Title" id="wm-widget-config-{{locale.LABEL_WIDGET_DESIGNER_TITLE}}"
                            placeholder="Title for the column" type="text" />
                        <!-- <wm-text scopedatavalue="field.displayName"
                            name="wm-widget-config-{{locale.LABEL_WIDGET_DESIGNER_TITLE}}"
                            placeholder="Title for the column"></wm-text> -->
                    </td>
                    <td>
                        <select class="app-select form-control" [ngModel]="field.widget"
                            name="wm-widget-config-{{locale.LABEL_WIDGET_DESIGNER_TITLE}}"
                            (ngModelChange)="updateWidgetTypeChange(field, $event)">
                            <option [selected]="true" value="{{locale.LABEL_SELECT_WIDGET_FOR_FIELD}}">{{locale.LABEL_SELECT_WIDGET_FOR_FIELD}}</option>
                            <option
                                *ngFor="let widget of fieldTypeWidgetTypeMap[extractTypefunc(field.type).toLowerCase()]; index as $index"
                                [value]="widget">{{widget}}</option>
                        </select>
                    </td>
                </tr>
            </tbody>
            <tbody *ngFor="let column of currentStep.columns">
                <tr *ngIf="!currentStep.hideHeaders" title="{{column.title}}">
                    <td colspan="5" class="column-title"><span class="text">{{column.title}}</span></td>
                </tr>
                <!-- TODO: Add toggleField -->
                <tr *ngFor="let field of column.fields" class="field" (click)="onRowSelect(field, 'field')"
                    [ngClass]="{'active': field === currentStep.selectedComponent.field}">
                    <td class="text-center select"><input class="app-checkbox" type="checkbox" [ngClass]="{'ng-empty': !field.pcDisplay, 'ng-not-empty': field.pcDisplay}"
                            [ngModel]="field.pcDisplay" (ngModelChange)="onColSelect('pcDisplay', field, $event)" /></td>
                    <td><span class="title-entity" *ngIf="field.relatedTable">[{{field.relatedTable}}]</span> <span  *ngIf="field.relatedTable" class="title" title="{{ field.relatedField }}">{{ field.relatedField  }}</span>  <span *ngIf="!field.relatedTable"  class="title" title="{{ field.field  || field.key }}">{{ field.field || field.key }}</span>   </td>
                    <td>
                        <input class="form-control app-textbox"
                            [ngModel]="field.displayName" pattern=".*" accesskey="" (ngModelChange)="updateFieldName(field, 'field', $event)"
                            (ngModelOptions)="{ updateOn:'blur, change', debounce: 0 ,allowInvalid: false}"
                            name="wm-widget-config-Title" id="wm-widget-config-{{locale.LABEL_WIDGET_DESIGNER_TITLE}}"
                            placeholder="Title for the column" type="text" />
                    </td>
                    <td><select *ngIf="activeLiveWidget === 'wm-table'" [ngModel]="field.widgetType"
                            (ngModelChange)="onWidgetChange(field, $event)" class="form-control app-select"
                            name="wm-widget-config-{{locale.LABEL_WIDGET_DESIGNER_TITLE}}"
                            placeholder="Widget type for the field">
                            <option selected [value]="undefined">{{locale.LABEL_SELECT_WIDGET}}</option>
                            <option *ngFor="let type of widgetTypes | keyvalue"
                            [value]="type.value">{{type.value}}</option>
                        </select>
                        <select *ngIf="activeLiveWidget !== 'wm-table'" class="app-select form-control"
                            [ngModel]="field.widget" name="wm-widget-config-{{locale.LABEL_WIDGET_DESIGNER_TITLE}}"
                            (ngModelChange)="updateWidgetTypeChange(field, $event)">
                            <option selected [value]="undefined">{{locale.LABEL_SELECT_WIDGET_FOR_FIELD}}</option>
                            <optgroup label="{{locale.LABEL_PREFERRED}}">
                                <option
                                    *ngFor="let widget of fieldTypeWidgetTypeMap[extractTypefunc(field.type).toLowerCase()] | keyvalue | orderBy:'value'; index as $index"
                                     value="{{widget.value}}">{{widget.value}}</option>
                            </optgroup>
                            <optgroup label="{{locale.LABEL_INSERT_OTHERS_TAB_TITLE}}">
                                <option
                                    *ngFor="let widget of otherWdgts[extractTypefunc(field.type).toLowerCase()] | keyvalue | orderBy:'value'; index as $index"
                                     value="{{widget.value}}">{{widget.value}}</option>
                            </optgroup>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="settings-actions col-xs-12"
        [ngClass]="{'hide': widgetType === 'wm-form' || activeLiveWidget === 'wm-form'}">
        <button title="{{locale.LABEL_MOVE_UP}}" class="wm-icon12 move-item-arrow wms wms-arrow-up"
            (click)="moveComponent(DIRECTION.UP, currentStep.columns)">
        </button>
        <button title="{{locale.LABEL_MOVE_DOWN}}" class="wm-icon12 move-item-arrow wms wms-arrow-down"
            (click)="moveComponent(DIRECTION.DOWN, currentStep.columns)">
        </button>
    </div>
</div>
